export const kidneyModuleOverview = [
  {
    id: "anatomy",
    title: "Kidney Anatomy: Part 1",
    description: "Learn the structure of the kidney",
    icon: "❤️",
    customImage: "module-kidney-anatomy.png",
    gradient: "from-teal-100 via-pink-50 to-rose-100 border-rose-300",
  },
  {
    id: "anatomy2",
    title: "Kidney Anatomy: Part 2",
    description: "Advanced kidney anatomy topics",
    icon: "❤️",
    customImage: "module-kidney-anatomy.png",
    gradient: "from-teal-100 via-pink-50 to-rose-100 border-rose-300",
  },
  {
    id: "anatomy3",
    title: "Kidney Anatomy: Part 3",
    description: "More advanced kidney anatomy topics",
    icon: "❤️",
    customImage: "module-kidney-anatomy.png",
    gradient: "from-teal-100 via-pink-50 to-rose-100 border-rose-300",
  },
  {
    id: "anatomy4",
    title: "Kidney Anatomy: Part 4",
    description: "Gerota's fascia, relations and the ureter",
    icon: "❤️",
    customImage: "module-kidney-anatomy.png",
    gradient: "from-teal-100 via-pink-50 to-rose-100 border-rose-300",
  },
  {
    id: "nephron",
    title: "The Nephron: Part 1",
    description: "Types, blood supply, glomerular filtration, and the PCT",
    icon: "🧪",
    customImage: "module-kidney-nephron.png",
    gradient: "from-teal-100 via-teal-50 to-emerald-100 border-emerald-300",
  },
  {
    id: "nephron2",
    title: "The Nephron: Part 2",
    description: "Loop of Henle, DCT, collecting duct, and tubular disorders",
    icon: "🧪",
    customImage: "module-kidney-nephron.png",
    gradient: "from-teal-100 via-teal-50 to-emerald-100 border-emerald-300",
  },
  {
    id: "histology",
    title: "Kidney Histology",
    description: "Microscopic structure of the kidney",
    icon: "🔬",
    customImage: "module-kidney-histology.png",
    gradient: "from-teal-100 via-teal-50 to-pink-100 border-rose-300",
  },
  {
    id: "physiology",
    title: "Renal Physiology: Part 1",
    description: "GFR, tubular function, and diuretics",
    icon: "⚡",
    gradient: "from-teal-100 via-pink-50 to-rose-100 border-rose-300",
  },
  {
    id: "physiology2",
    title: "Renal Physiology: Part 2",
    description: "Hormonal regulation and electrolyte balance",
    icon: "⚡",
    gradient: "from-teal-100 via-pink-50 to-rose-100 border-rose-300",
  },
  {
    id: "physiology3",
    title: "Renal Physiology: Part 3",
    description: "Acid-base balance, AKI, CKD, and glomerular disease",
    icon: "⚡",
    gradient: "from-teal-100 via-pink-50 to-rose-100 border-rose-300",
  },
  {
    id: "disease",
    title: "Kidney Diseases: Glomerular",
    description: "FSGS, membranous, diabetic nephropathy, amyloidosis, lupus nephritis, RPGN",
    icon: "🩺",
    gradient: "from-rose-100 via-pink-50 to-purple-100 border-purple-300",
  },
  {
    id: "disease2",
    title: "Kidney Diseases: Tubulointerstitial & Vascular",
    description: "ATN, AIN, pyelonephritis, renal artery stenosis, HUS, TTP, ADPKD",
    icon: "🩺",
    gradient: "from-rose-100 via-pink-50 to-purple-100 border-purple-300",
  },
  {
    id: "disease3",
    title: "Kidney Diseases: Stones, Infections & Tumours",
    description: "Nephrolithiasis, UTIs, RCC, urothelial carcinoma, Wilms' tumour",
    icon: "🩺",
    gradient: "from-rose-100 via-pink-50 to-purple-100 border-purple-300",
  },
  {
    id: "pharmacology",
    title: "Renal Pharmacology: Part 1",
    description: "Anaemia of CKD, CKD mineral bone disease, anticoagulation in nephrotic syndrome, drug prescribing in CKD",
    icon: "💊",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-400",
  },
  {
    id: "pharmacology2",
    title: "Renal Pharmacology: Part 2",
    description: "Transplant immunosuppression: induction, calcineurin inhibitors, antiproliferatives, mTOR inhibitors & rejection treatment",
    icon: "💊",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-400",
  },
  {
    id: "surgery",
    title: "Renal Surgery: Part 1",
    description: "Renal biopsy, JJ stents & percutaneous nephrostomy, nephrectomy, radical cystectomy & urinary diversion",
    icon: "🏥",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-400",
  },
  {
    id: "surgery2",
    title: "Renal Surgery: Part 2",
    description: "Renal transplantation, post-transplant complications, PUJ obstruction & pyeloplasty, VUR surgery",
    icon: "🏥",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-400",
  },
];
